import types from '@/vuex/administracao/mutations-types'

const mutations = {
  [types.ABRIR_DIALOG_EDICAO]: (state) => {
    state.dialogEdicao = true
  },
  [types.FECHAR_DIALOG_EDICAO]: (state) => {
    state.dialogEdicao = false
  },
  [types.SET_LISTA_ITENS_GLOSSARIO]: (state, payload) => {
    state.listaItensGlossario = payload.listaItensGlossario
  },
  [types.CRIAR_ITEM_GLOSSARIO]: (state, payload) => {
    state.listaItensGlossario.push(payload.itemGlossario)
  },
  [types.EDITAR_ITEM_GLOSSARIO]: (state, payload) => {
    const listaIds = state.listaItensGlossario.map((item) => item.idItemGlossario)
    const index = listaIds.indexOf(payload.itemGlossario.idItemGlossario)
    Object.assign(state.listaItensGlossario[index], payload.itemGlossario)
  },
  [types.EXCLUIR_ITEM_GLOSSARIO]: (state, payload) => {
    state.listaItensGlossario.splice(state.listaItensGlossario.indexOf(payload.itemGlossario), 1)
  },
  [types.SET_LISTA_TIPOS_DOCUMENTO]: (state, payload) => {
    state.listaTiposDocumento = payload.listaTiposDocumento
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/administracao/mutations.js